import HelloWorld from './components/HelloWorld.vue';
import EventSelector from './components/EventSelector.vue';
export default {
    name: 'App',
    components: {
        HelloWorld,
        EventSelector
    }
};
